import {defineMessages} from 'react-intl';

export default defineMessages({
	errorMsg: {
		id: 'wishlist.popup.errorMsg',
		defaultMessage: 'Failed to add an item to wishlist'
	},
	addedToLabel: {
		id: 'productView.button.addedToWishlist',
		defaultMessage: 'Added to wishlist'
	},
	addToLabel: {
		id: 'productView.button.addToWishlist',
		defaultMessage: 'Add to wishlist'
	},
});
